import { Injectable } from "@angular/core";

import { CustomerDecisionTypeEnum } from "../../core/enums/customer-decision-type.enum";

import { ICustomer } from "../../core/interfaces/customer.interface";

@Injectable({
  providedIn: "root",
})
export class CustomerService {
  private customer: ICustomer;

  public getCustomer() {
    return this.customer;
  }

  public isNewLoanDecision() {
    return this.customer.decisionType === CustomerDecisionTypeEnum.NEW_LOAN;
  }

  public setCustomer(customer: ICustomer) {
    this.customer = customer;
  }
}
